import React, { useState } from 'react';
import { sendFeedback } from '../../services/feedback';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  VStack,
  Text,
  Textarea,
  ButtonGroup,
  useToast,
  Input,
  Box,
} from '@chakra-ui/react';

interface FeedbackModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({ isOpen, onClose }) => {
  const [selectedType, setSelectedType] = useState<string>('');
  const [comment, setComment] = useState('');
  const [name, setName] = useState('');
  const [sport, setSport] = useState('');
  const toast = useToast();

  const handleSubmit = async () => {
    try {
      await sendFeedback(selectedType, comment, name, sport);
      
      // Close modal and reset form first
      onClose();
      setSelectedType('');
      setComment('');
      setName('');
      setSport('');

      // Show toast after modal is closed
      toast({
        duration: 5000,
        position: "top",
        render: () => (
          <Box
            position="fixed"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
            color='white'
            p={4}
            bg='blue.500'
            textAlign="center"
            borderRadius="md"
            boxShadow="lg"
            fontSize="lg"
          >
            Thanks for your feedback!
          </Box>
        ),
      });

    } catch (error) {
      toast({
        title: "Error sending feedback",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const userTypes = ['Social Player', 'Competitive', 'Club Manager', 'Other'];

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent bg="#191919" color="white">
        <ModalCloseButton />
        <ModalBody pb={6}>
            <VStack spacing={4} align="stretch">
              <VStack spacing={2} width="100%" align="center">
                {userTypes.map((type) => (
                  <Button
                    key={type}
                    variant={selectedType === type ? "solid" : "outline"}
                    colorScheme="blue"
                    onClick={() => setSelectedType(type)}
                    borderRadius="3px"
                    size="sm"
                    fontSize="sm"
                    width="50%"
                  >
                    {type}
                  </Button>
                ))}
              </VStack>
              
              <Input
                placeholder="Tennis, Padel, Pickleball etc"
                value={sport}
                onChange={(e) => setSport(e.target.value)}
                size="md"
                maxLength={30}
              />
              
              <Textarea
                placeholder="Your feedback (max 180 characters)"
                maxLength={180}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                resize="vertical"
                minH="100px"
              />
              
              <Input
                placeholder="Name (Optional)"
                value={name}
                onChange={(e) => setName(e.target.value)}
                size="md"
                maxLength={30}
              />
              
              <Button
                colorScheme="blue"
                onClick={handleSubmit}
                isDisabled={!selectedType || !comment}
                mt={4}
                borderRadius="3px"
              >
                Submit
              </Button>
            </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default FeedbackModal;
